const sum = require('hash-sum');
import qs from 'qs';
export default class {
    constructor() {
        this.url = location.hash;
        this.params = {};
        // The hashSignature is used to uniquely identify a set of params
        this.hashSignature = '';

        // Setup the hashchange listener
        window.addEventListener("hashchange", (event) => { this.hashChanged(event) });

        // We're dispatching a custom event when the hash changes that contains the params and hash of the search query
        // Not all browsers support custom events yet, so polyfilling
        this.customEventPolyfill();

        // Disabling this as we are setting the initial params using loadFromParams() on page load
        this.convertHashIntoParams();
    }

    customEventPolyfill() {
        if ( typeof window.CustomEvent === "function" ) return false;

        function CustomEvent ( event, params ) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    }

    /**
     * Parses the hash fragment portion of the URL for query parameters and stores them in an array
     */
    convertHashIntoParams() {
        if (this.url == '') {
            return {};
        }
        this.params = qs.parse(this.url);
        this.hashSignature = sum(this.params);
        return this.params;
    }

    /**
     * Parses the hash fragment portion of the URL for query parameters and stores them in an array
     */
    convertHashIntoParamsAndTriggerEvent() {
        if (this.url == '') {
            return {};
        }
        this.convertHashIntoParams();
        this.triggerEvent();
        return this.params;
    }

    /**
     * Update the current parameters and trigger a URL update
     *
     * @param {array} params
     * @param {boolean} forceUpdate (optional) defaults to false, triggers paramchange event when true
     */
    updateParams(params, forceUpdate = false) {
        let newParams = {};
        // Convert all of the duplicate keys with [] in the name into arrays
        Object.keys(params).forEach(key => {
            const cleanKey = key.replace('[]', '');

            // If the value is an array, we need to iterate over it to get all values
            if (Array.isArray(params[key])) {
                if (params[key].length == 1) {
                    newParams[cleanKey] = params[key][0];
                    return;
                }
                params[key].forEach(element => {
                    if (typeof newParams[cleanKey] !== 'undefined') {
                        newParams[cleanKey].push(element);
                        return;
                    }
                    newParams[cleanKey] = [element];
                });
                return;
            }

            newParams[cleanKey] = params[key];
        });


        this.hashSignature = sum(newParams);
        this.params = newParams;

        const newHash = qs.stringify(newParams);
        const oldHash = location.hash.substr(1);

        if (oldHash !== newHash) {
            location.hash = '#' + newHash;
            return true;
        }

        if (forceUpdate) {
            this.triggerEvent();
            return true;
        }

        return false;
    }

    /**
     * Trigger the paramchange event
     */
    triggerEvent() {
        const event = new CustomEvent("paramchange", {
            detail: {
                params: this.params,
                hash: this.hashSignature
            }
        });
        window.dispatchEvent(event);
    }

    /**
     * Event handler for the hash fragment changing. When triggered it will automatically parse the new fragment for query parameters
     * @param {*} event
     */
    hashChanged(event) {
        this.url = location.hash.substr(1);

        this.convertHashIntoParamsAndTriggerEvent();
    }
}